import { EventEmitter, Injectable } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable()
export class NavService {
  appDrawer: any;
  showToolbar$ = new Subject<boolean>();
  showBreadcrumb$ = new Subject<boolean>();
  containerTopGap$ = new Subject<number>();
  currentUrl = new BehaviorSubject<string>(undefined);

  constructor(private router: Router) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl.next(event.urlAfterRedirects);
      }
    });
  }

  closeNav() {
    if (this.appDrawer) {
      this.appDrawer.close();
    }
  }

  openNav() {
    this.appDrawer.open();
  }
}
